/* Record where each order came from, on the order itself.

   Shopify's own "Conversion summary" only fills in when its analytics cookies are
   allowed, and on this store roughly seven orders in ten come through with nothing.
   This captures the same facts first-party — campaign tags, referrer, landing page —
   keeps them for 30 days, and writes them onto the cart, so they appear on the order in
   the admin under "Additional details" and in any order export.

   First touch is kept separately from last touch: the first is what earned the customer,
   the last is what closed them, and for a considered purchase like a door they are often
   weeks apart.

   Only marketing metadata is stored — no personal data, nothing about the individual.
*/
(function () {
  var KEY = 'd2f-attribution';
  var WRITTEN = 'd2f-attribution-written';
  var MAX_AGE_DAYS = 30;

  function params() {
    try {
      return new URLSearchParams(window.location.search);
    } catch (e) {
      return new URLSearchParams('');
    }
  }

  function cookieGet(name) {
    var hit = ('; ' + document.cookie).split('; ' + name + '=');
    return hit.length === 2 ? decodeURIComponent(hit.pop().split(';').shift()) : null;
  }

  function cookieSet(name, value, days) {
    try {
      document.cookie =
        name + '=' + encodeURIComponent(value) + ';path=/;max-age=' + days * 86400 + ';SameSite=Lax';
    } catch (e) {}
  }

  function readStore() {
    try {
      var raw = localStorage.getItem(KEY) || cookieGet(KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || !data.firstSeen) return null;
      var age = (Date.now() - data.firstSeen) / 86400000;
      return age > MAX_AGE_DAYS ? null : data;
    } catch (e) {
      return null;
    }
  }

  function save(data) {
    var raw = JSON.stringify(data);
    // Written to both stores on purpose: the in-app browsers used by Instagram and
    // Facebook - the very traffic Shopify is failing to attribute - restrict one or the
    // other, so whichever survives keeps the first touch alive.
    try {
      localStorage.setItem(KEY, raw);
    } catch (e) {}
    cookieSet(KEY, raw, MAX_AGE_DAYS);
  }

  /* Work out what brought this particular visit in. */
  function currentTouch() {
    var q = params();
    var ref = document.referrer || '';
    var host = '';
    try {
      host = ref ? new URL(ref).hostname.replace(/^www\./, '') : '';
    } catch (e) {}

    var source = q.get('utm_source') || '';
    var medium = q.get('utm_medium') || '';

    if (!source) {
      if (q.get('gclid')) {
        source = 'google';
        medium = medium || 'cpc';
      } else if (q.get('fbclid')) {
        source = 'facebook';
        medium = medium || 'social';
      } else if (q.get('msclkid')) {
        source = 'bing';
        medium = medium || 'cpc';
      } else if (host && host.indexOf(window.location.hostname.replace(/^www\./, '')) === -1) {
        source = host;
        medium = medium || (/google|bing|yahoo|duckduckgo|ecosia/.test(host) ? 'organic' : 'referral');
      } else if (!ref) {
        source = 'direct';
        medium = medium || 'none';
      }
    }

    return {
      source: source || 'direct',
      medium: medium || 'none',
      campaign: q.get('utm_campaign') || '',
      term: q.get('utm_term') || '',
      content: q.get('utm_content') || '',
      landing: window.location.pathname + window.location.search.slice(0, 200),
      referrer: ref.slice(0, 200),
      at: Date.now(),
    };
  }

  function record() {
    var touch = currentTouch();
    var data = readStore();

    // A direct hit mid-journey must not overwrite the campaign that started it.
    var meaningful = touch.source !== 'direct';

    if (!data) {
      data = { firstSeen: Date.now(), first: touch, last: touch };
    } else if (meaningful) {
      data.last = touch;
    }
    save(data);
    return data;
  }

  function attributes(data) {
    function label(touch) {
      var bits = [touch.source];
      if (touch.medium && touch.medium !== 'none') bits.push('(' + touch.medium + ')');
      if (touch.campaign) bits.push('· ' + touch.campaign);
      return bits.join(' ');
    }
    var out = {
      'Came from': label(data.first),
      'Landed on': data.first.landing,
    };
    if (data.first.referrer) out['Referrer'] = data.first.referrer;
    if (label(data.last) !== label(data.first)) out['Last visit from'] = label(data.last);
    if (data.first.term) out['Search term'] = data.first.term;
    if (data.first.content) out['Ad content'] = data.first.content;
    out['First seen'] = new Date(data.firstSeen).toISOString().slice(0, 10);
    return out;
  }

  function write(data) {
    var body = JSON.stringify({ attributes: attributes(data) });
    var already = null;
    try {
      already = sessionStorage.getItem(WRITTEN);
    } catch (e) {
      already = window.__d2fAttrWritten || null; // storage blocked: de-dupe in memory
    }
    if (already === body) return;
    window.__d2fAttrWritten = body;

    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/update.js' : '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: body,
    })
      .then(function () {
        try {
          sessionStorage.setItem(WRITTEN, body);
        } catch (e) {}
      })
      .catch(function () {
        /* never let analytics break a checkout */
      });
  }

  var data = record();

  // Fire on every visit, not just once there is a cart, and without waiting on any
  // consent signal: the attribution rides on the cart Shopify needs anyway. If storage is
  // blocked the values simply live in memory for this page and are still written.
  function fire() {
    write(data);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fire);
  } else {
    fire();
  }

  // ...and again right after an add to cart, which is the moment the cart first exists.
  var nativeFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var href = typeof url === 'string' ? url : url && url.url;
    var call = nativeFetch.apply(this, arguments);
    if (href && href.indexOf('/cart/add') > -1) {
      call.then(function () {
        setTimeout(function () {
          write(data);
        }, 300);
      });
    }
    return call;
  };
})();
